import { Box, Button, Text, Progress } from "@chakra-ui/react"
import { useEffect, useState } from "react"
import { useDispatch, useSelector } from "react-redux"
import { myActivityReset, setHeaderText } from "../redux/actions/action"
import { formatMyActivityData, loadMyActivity } from "../redux/api/apiCalls"
import Activities from "./Activities"

export default function MyActivity() {
    const { myActivityData, isLoading } = useSelector(state => state.myActivityState)
    const [visibleData, setVisibleData] = useState([])
    const [loadMoreVisible, setLoadMoreVisible] = useState(false);
    const dispatch = useDispatch()

    const loadMoreHandler = () => {
        const currentItemsCount = visibleData.reduce((length, activity) => length + activity.length, 0)
        setVisibleData(formatMyActivityData(myActivityData.slice(0, currentItemsCount + 10)))
        setLoadMoreVisible(currentItemsCount + 10 < myActivityData.length)
    }

    useEffect(() => {
        dispatch(setHeaderText('My Activity'))
        dispatch(loadMyActivity())
        return () => dispatch(myActivityReset())
        // eslint-disable-next-line
    }, [])

    useEffect(() => {
        if (!isLoading && myActivityData.length > 0) {
            console.log(myActivityData)
            setVisibleData(formatMyActivityData(myActivityData.slice(0, 10)))
            setLoadMoreVisible(myActivityData.length > 10)
        }
    }, [myActivityData, isLoading])

    return (
        <Box
            px='1rem'
            w='95%'
            minH='90vh'
            mb='1rem'
        >
            <Text
                fontSize={['20px', '25px', '30px', '40px']}
                d={['none', 'none', 'none', 'none', 'flex']}
                fontWeight='900'
                style={{ fontFamily: 'Mulish, sans-serif' }}
                pt='2rem'
                mb='2rem'
            >
                My Activity
            </Text>

            {
                isLoading ? <Progress isIndeterminate size='xs' width='100%' /> :
                   visibleData.length > 0 ? visibleData.map((activity, idx) => <Activities key={idx} activity={activity} />) : 
                   <Box
                border='1px solid rgba(0, 0, 0, 0.1)'
                borderRadius='10px'
                boxShadow='0px 2px 10px rgba(0, 0, 0, 0.1)'
                w='100%'
                bg='#ffffff'
                d='flex'
                flexDir='column'
                justifyContent = 'center'
                alignItems = 'center'
                p='2rem'
                mt='1rem'
            >
                <Text style={{ fontFamily: 'Mulish, sans-serif' }} fontWeight='700' fontSize={['14px', '16px', '16px', '20px']}>
                        Nothing to display!
                    </Text>
            </Box>
            }

            <Box width="100%" d="flex" justifyContent="center" alignItems="center" mt='1.5rem'>
                {loadMoreVisible && (
                    <Button
                        color="#00000099"
                        style={{ fontFamily: "Mulish, sans-serif" }}
                        fontWeight="700"
                        fontSize={["12px", "14px", "16px", "18px"]}
                        border="2px solid rgba(0, 0, 0, 0.1)"
                        boxShadow="0px 3px 16px rgba(0, 0, 0, 0.1)"
                        borderRadius="xl"
                        py={["0.5rem", "0.75rem", "1rem", "1.5rem"]}
                        px={["0.75rem", "1rem", "1.5rem", "2rem"]}
                        m="2rem"
                        bg="#ffffff"
                        onClick={loadMoreHandler}
                    >
                        Load More...
                    </Button>
                )}
            </Box>
        </Box>
    )
}